import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Buffer } from "buffer";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DataTable from "react-data-table-component";
import Nav from "./Nav";
import Footer from "./Footer";
import useFetch from "../Components/UseFetch";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { IconButton } from "@mui/material";
import { addCommas, cleanSpecialNaming } from "../HelperFx/common.js";

// import { salesOrders as SO, salesOrderLines } from '../HelperFx/datalinks';
import {
  postedSalesInvoices,
  postedSalesInvoicesLines,
} from "../HelperFx/datalinks";

import verifyToken from "../HelperFx/verifyJwt.js";
import "./home.css";
import "./salesquote.css";

const REACT_UNAME = process.env.REACT_APP_API_USERNAME;
const REACT_PWD = process.env.REACT_APP_API_PASSWORD;
const REACT_DATA_URL = process.env.REACT_APP_API_DATA_URL;
const REACT_APP_COMPANY_URL = process.env.REACT_APP_COMPANY;

const eq = " eq ";
const filter = "?$filter =";

const formatDate = (dateString) => {
  if (!dateString || dateString === "0001-01-01") return "";

  const date = new Date(dateString);
  return date.toISOString().split("T")[0];
};

const inputList = [
  {
    type: "text",
    name: "number",
    caption: "Document No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "customerNo",
    caption: "Customer No.",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "customerName",
    caption: "Customer Name",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "billToAddress1",
    caption: "Bill To Address",
    background: "lightgray",
    currency: false,
  },
  {
    type: "date",
    name: "documentDate",
    caption: "Document Date",
    background: "lightgray",
    currency: false,
  },
  // {type: "date",name: 'postingDate',caption: 'Posting Date',background: 'lightgray' },
  {
    type: "date",
    name: "dueDate",
    caption: "Due Date",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "currencyCode",
    caption: "Currency",
    background: "lightgray",
    currency: false,
  },
  {
    type: "text",
    name: "amount",
    caption: "Amount",
    background: "lightgray",
    currency: true,
  },
  {
    type: "text",
    name: "amountIncludingVat",
    caption: "Amount Including VAT",
    background: "lightgray",
    currency: true,
  },
];

const CustomTable = () => {
  const location = useLocation();
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );
  const jwttoken = sessionStorage.getItem("authToken");
  const { custName, userName, password } = verifyToken(jwttoken);

  const salesLinesUrl = `${REACT_DATA_URL}${postedSalesInvoicesLines}${filter}documentnumber${eq}'${location.state.number}'&${REACT_APP_COMPANY_URL}`;
  //Console.log('Sales Lines URL:', salesLinesUrl);

  const { data: salesLine, error } = useFetch(salesLinesUrl, token);

  //Console.log('Sales Line Response:', salesLine);
  // if (error) Console.log('Sales Line Error:', error);

  const columns = [
    {
      name: "Type",
      selector: (row) => row.lineType || row.type || "",
      sortable: true,
    },
    {
      name: "Item",
      selector: (row) => row.itemNo || "",
      sortable: true,
      cell: (row) => <span title={row.itemNo}>{row.itemNo}</span>,
    },
    {
      name: "Description",
      selector: (row) => row.description || "",
      sortable: true,
      cell: (row) => <span title={row.description}>{row.description}</span>,
    },
    {
      name: "Qty",
      selector: (row) => row.quantity || row.Quantity || 0,
      sortable: true,
    },
    {
      name: "Unit Of Measure",
      selector: (row) => row.unitOfMeasure || "",
      sortable: true,
      cell: (row) => <span title={row.unitOfMeasure}>{row.unitOfMeasure}</span>,
    },
    {
      name: "Price",
      selector: (row) => addCommas(row.unitPrice) || 0,
      sortable: true,
    },
    {
      name: "Total Price",
      selector: (row) => addCommas(row.lineAmount) || 0,
      sortable: true,
    },
  ];

  // Add a loading state
  if (!salesLine) return <div>Loading Credit Memo lines...</div>;

  return (
    <>
      <DataTable
        columns={columns}
        data={salesLine?.value || []}
        pagination
        customStyles={{
          rows: {
            style: {
              minHeight: "33px",
            },
          },
          columns: {
            style: {
              minHeight: "33px",
            },
          },
        }}
        noDataComponent="No sales lines found"
      />
      <div className="mt-2">
        {error && (
          <div className="text-red-500">
            Error loading Credit Memo lines: {error.message}
          </div>
        )}
      </div>
    </>
  );
};

const AccordionUsage = () => {
  const location = useLocation();
  const token = Buffer.from(`${REACT_UNAME}:${REACT_PWD}`, "utf8").toString(
    "base64",
  );
  const jwttoken = sessionStorage.getItem("authToken");
  const { custName, userName, password } = verifyToken(jwttoken);

  const { data: salesInvoice } = useFetch(
    `${REACT_DATA_URL}${postedSalesInvoices}?${REACT_APP_COMPANY_URL}&$filter = number eq '${location.state.number}'`,
    token,
  );

  return (
    <div className="Accord-Scrollable">
      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          style={{
            color: "#333",
            margin: "3px !important",
            padding: "3px !important",
            borderBottom: "1px solid #000000",
            fontWeight: 800,
          }}
        >
          Posted Purchase Invoices
        </AccordionSummary>
        <AccordionDetails>
          <form action="">
            <div className="input-row-group">
              {inputList.map((input, index) => (
                <div className="input-group" key={index}>
                  <label style={{ fontWeight: 700 }}>{input.caption}</label>
                  <input
                    type={input.type}
                    name={input.name}
                    id={input.name}
                    value={
                      input.type === "date"
                        ? formatDate(salesInvoice?.value[0]?.[input.name])
                        : input.currency === true
                        ? addCommas(salesInvoice?.value[0]?.[input.name])
                        : cleanSpecialNaming(
                            salesInvoice?.value[0]?.[input.name] || "",
                          )
                    }
                    readOnly
                    className="input-level"
                    style={{ backgroundColor: input.background }}
                  />
                </div>
              ))}
            </div>
          </form>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
          style={{
            color: "#333",
            borderBottom: "1px solid #000000",
            margin: 0,
            fontWeight: 800,
          }}
        >
          Invoice Lines
        </AccordionSummary>
        <AccordionDetails>
          <CustomTable />
        </AccordionDetails>
      </Accordion>

      <style>
        {`
          ::placeholder {
            color: black;
          }
        `}
      </style>
    </div>
  );
};

const PostedSalesInvoice = () => {
  return (
    <div className="Home">
      <Nav />
      <div className="dash-main">
        <div className="squote">
          <div className="firsttab">
            <IconButton component={Link} to="/PostedPurchaseInvoices">
              <ArrowBackIcon sx={{ fontSize: "1.5rem" }} />
            </IconButton>
            <span>Posted Purchase Invoice</span>
            {/* <div className="actions">
              <a className="btn btn-sm border-black rounded-pill px-3 mx-2 action-btn" role="button">Print</a>
            </div> */}
          </div>
          <div className="listTable my-4">
            <AccordionUsage className="Accord-Scrollable" />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PostedSalesInvoice;
